<script setup>
defineProps({
    property: Object
})
</script>

<script>
export default {
    data(){
        return {
            title: '',
            price: '',
            primary_image: '',
            location: '',
            propertyPrice: []
        }
    },
    mounted(){
        let languages = this.property.languages;
        let images = (this.property.images != null) ? JSON.parse(this.property.images) : [];
        this.location = this.property.location != null ? JSON.parse(JSON.stringify(this.property.location)) : null;

        if(images.length > 0){
            let image = JSON.parse(JSON.stringify(images[0]));
            if(image){
                image = JSON.parse(JSON.stringify(image));
                if(image){
                    this.primary_image = JSON.parse(JSON.stringify(image.full)).link
                }
            }
        }

        if(languages){
            languages = JSON.parse(languages);
            if(languages){
                this.title = languages[0].title;
            }
        }

        if(this.property.price != null){
            let price = JSON.parse(this.property.price);
            if(price){
                if(price.prices){
                    price = JSON.parse(JSON.stringify(price.prices));
                    if(price){
                        price.forEach(element => {
                            this.propertyPrice.push(element.value + ' AED / ' + element.period)
                        });
                    }
                }
            }
        }
    }
}

// (location ? ' in ' + ((location.tower != null ? location.tower + ', ' : '') + (location.sub_community != null ? location.sub_community + ', ' : '') + (location.community != null ? location.community + ', ' : '') + (location.city != null ? location.city : '')) + '.': '')
</script>

<template>
    <li class="splide__slide">
        <a :href="route('property.showSlug', {property: property.hash})">
            <div class="property-image-wrapper">
                <figure>
                    <img :src="primary_image" class="with-loading" onerror="this.src='/images/homepage/banner/banner-img.jpg'">
                </figure>
                <div class="property-info text-dark">
                    <p class="property-type text-capitalize text-truncate" v-if="property.type && property.type.name">
                        {{ property.type.name }} <span v-if="location && location.community">in {{ location.community }}.</span>
                    </p>
                    <h3 class="property-location" v-html="title">
                    </h3>
                    <h4 class="property-value">{{ propertyPrice[0] }}</h4>
                    <img :src="asset('/images/properties/residential.png')">
                </div>
            </div>
        </a>
    </li>
</template>